import { RouteRecordRaw } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/home/Home.vue'),
      },
    ],
  },
  {
    path: '/explore-plants',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'ExplorePlants',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/ExplorePlants.vue'),
      },
    ],
  },
  {
    path: '/plant/:id',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Plant',
        component: () =>
          import(/* webpackChunkName: "plant" */ '@/views/plant/Plant.vue'),
      },
    ],
  },
  {
    path: '/search',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'SearchResults',
        component: () =>
          import(/* webpackChunkName: "search" */ '@/views/SearchResults.vue'),
      },
    ],
  },
  {
    path: '/my-plants',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'MyPlants',
        component: () =>
          import(
            /* webpackChunkName: "my-plants" */ '@/views/my-plants/MyPlants.vue'
          ),
      },
    ],
  },
  {
    path: '/calendar',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'Calendar',
        component: () =>
          import(
            /* webpackChunkName: "calendar" */ '@/views/calendar/Calendar.vue'
          ),
      },
    ],
  },
] as RouteRecordRaw[];
